var blockBundles;

try {
  blockBundles = {
    metaslug_sinhnhat1tuoi: {
      header: {
        header: {
          html: require("../../metaslug_sinhnhat1tuoi/header/header.html.twig"),
          scss: require("../../metaslug_sinhnhat1tuoi/header/header.scss"),
          js: require("../../metaslug_sinhnhat1tuoi/header/header.js"),
          dir: "metaslug_sinhnhat1tuoi/header/header",
        },
      },
      content: {
        vongquay: {
          html: require("../../metaslug_sinhnhat1tuoi/vongquay/vongquay.html.twig"),
          scss: require("../../metaslug_sinhnhat1tuoi/vongquay/vongquay.scss"),
          js: require("../../metaslug_sinhnhat1tuoi/vongquay/vongquay.js"),
          dir: "metaslug_sinhnhat1tuoi/vongquay/vongquay",
        },
        milestone: {
          html: require("../../metaslug_sinhnhat1tuoi/milestone/milestone.html.twig"),
          scss: require("../../metaslug_sinhnhat1tuoi/milestone/milestone.scss"),
          js: require("../../metaslug_sinhnhat1tuoi/milestone/milestone.js"),
          dir: "metaslug_sinhnhat1tuoi/milestone/milestone",
        },
        event: {
          html: require("../../metaslug_sinhnhat1tuoi/event/event.html.twig"),
          scss: require("../../metaslug_sinhnhat1tuoi/event/event.scss"),
          js: require("../../metaslug_sinhnhat1tuoi/event/event.js"),
          dir: "metaslug_sinhnhat1tuoi/event/event",
        },

        required_popup: {
          html: require("../../metaslug_sinhnhat1tuoi/required_popup/required_popup.html.twig"),
          scss: require("../../metaslug_sinhnhat1tuoi/required_popup/required_popup.scss"),
          js: require("../../metaslug_sinhnhat1tuoi/required_popup/required_popup.js"),
          dir: "metaslug_sinhnhat1tuoi/required_popup/required_popup",
        },
      },
      footer: {
        footer: {
          html: require("../../metaslug_sinhnhat1tuoi/footer/footer.html.twig"),
          scss: require("../../metaslug_sinhnhat1tuoi/footer/footer.scss"),
          js: require("../../metaslug_sinhnhat1tuoi/footer/footer.js"),
          dir: "metaslug_sinhnhat1tuoi/footer/footer",
        },
      },
      float: {
        float_top: {
          html: require("../../metaslug_sinhnhat1tuoi/float_top/float_top.html.twig"),
          scss: require("../../metaslug_sinhnhat1tuoi/float_top/float_top.scss"),
          js: require("../../metaslug_sinhnhat1tuoi/float_top/float_top.js"),
          dir: "metaslug_sinhnhat1tuoi/float_top/float_top",
        },
        float_left: {
          html: require("../../metaslug_sinhnhat1tuoi/float_left/float_left.html.twig"),
          scss: require("../../metaslug_sinhnhat1tuoi/float_left/float_left.scss"),
          js: require("../../metaslug_sinhnhat1tuoi/float_left/float_left.js"),
          dir: "metaslug_sinhnhat1tuoi/float_left/float_left",
        },
        float_right: {
          html: require("../../metaslug_sinhnhat1tuoi/float_right/float_right.html.twig"),
          scss: require("../../metaslug_sinhnhat1tuoi/float_right/float_right.scss"),
          js: require("../../metaslug_sinhnhat1tuoi/float_right/float_right.js"),
          dir: "metaslug_sinhnhat1tuoi/float_right/float_right",
        },
      },
    },
  };
} catch (error) {
  console.log(error);
}

export default blockBundles;